/* unplugin-vue-components disabled */import __unplugin_components_3 from 'D:/workspace/space-time-web/src/components/TreeSelect/index.vue';
import __unplugin_components_2 from 'D:/workspace/space-time-web/src/components/Pagination/index.vue';
import __unplugin_components_1 from 'D:/workspace/space-time-web/src/components/DictTag/index.vue';
import __unplugin_components_0 from 'D:/workspace/space-time-web/src/components/RightToolbar/index.vue';
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "page"
};
const _hoisted_2 = {
  class: "ele-wrapper-bgCard"
};
const _hoisted_3 = {
  class: "app-container"
};
const _hoisted_4 = {
  class: "head-container"
};
const _hoisted_5 = {
  class: "head-container"
};
const _hoisted_6 = {
  class: "dialog-footer"
};
const _hoisted_7 = ["title"];
const _hoisted_8 = {
  class: "dialog-footer"
};
const _hoisted_9 = {
  style: {
    "width": "100%",
    "height": "60rem",
    "display": "flex",
    "flex-wrap": "wrap",
    "border": "0.1rem solid #606266",
    "border-radius": "1rem"
  }
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 0,
  style: {
    "color": "red",
    "font-size": "3rem",
    "font-weight": "bold"
  }
};
const _hoisted_12 = {
  key: 1,
  class: "video-text"
};
const _hoisted_13 = {
  class: "weather-class"
};
const _hoisted_14 = {
  cellspacing: "0",
  style: {
    "width": "100%",
    "table-layout": "fixed"
  }
};
const _hoisted_15 = {
  colspan: "4",
  class: "el-table__cell is-leaf"
};
const _hoisted_16 = {
  class: "cell"
};
const _hoisted_17 = {
  colspan: "4",
  class: "el-table__cell is-leaf"
};
const _hoisted_18 = {
  class: "cell"
};
const _hoisted_19 = {
  colspan: "2",
  class: "el-table__cell is-leaf"
};
const _hoisted_20 = {
  class: "cell"
};
const _hoisted_21 = {
  colspan: "2",
  class: "el-table__cell is-leaf"
};
const _hoisted_22 = {
  class: "cell"
};
const _hoisted_23 = {
  colspan: "2",
  class: "el-table__cell is-leaf"
};
const _hoisted_24 = {
  class: "cell"
};
const _hoisted_25 = {
  colspan: "2",
  class: "el-table__cell is-leaf"
};
const _hoisted_26 = {
  class: "cell"
};
const _hoisted_27 = {
  colspan: "2",
  class: "el-table__cell is-leaf"
};
const _hoisted_28 = {
  class: "cell"
};
const _hoisted_29 = {
  colspan: "2",
  class: "el-table__cell is-leaf"
};
const _hoisted_30 = {
  class: "cell"
};
const _hoisted_31 = {
  colspan: "2",
  class: "el-table__cell is-leaf"
};
const _hoisted_32 = {
  class: "cell"
};
const _hoisted_33 = {
  colspan: "2",
  class: "el-table__cell is-leaf"
};
const _hoisted_34 = {
  class: "cell"
};
const _hoisted_35 = {
  class: "data-class"
};
const _hoisted_36 = {
  key: 0,
  class: "loading"
};
const _hoisted_37 = {
  key: 1,
  class: "data-succ"
};
const _hoisted_38 = {
  key: 2,
  class: "data-err"
};
const _hoisted_39 = {
  class: "video-title"
};
const _hoisted_40 = {
  style: {
    "height": "3rem",
    "text-align": "right",
    "margin-top": "2rem",
    "padding-right": "3rem"
  }
};
const _hoisted_41 = {
  key: 0,
  class: "list"
};
const _hoisted_42 = ["onClick"];
const _hoisted_43 = {
  class: "zngaojing"
};
const _hoisted_44 = {
  class: "zngaojingright"
};
const _hoisted_45 = {
  class: "zitiyangshi"
};
const _hoisted_46 = {
  class: "dialog-footer"
};
const _hoisted_47 = {
  class: "dialog-footer"
};
import { listTask, getTaskList, getTreeselectDeviceList, addTask, updateTask, delTask, stopTaskById, startTask, getTaskingCountEnough, getTask, getMessageInfo, sendEmail, shareTask, getUsersByTaskId } from '@/api/base/taskmanager';
import { getAlarmList, getPointList } from "@/api/alarm/alarmInfo";
import { deviceVideoPlay, getTreeselectUserList } from "@/api/base/device";
import DatePicker from "@/components/DatePicker";
import player from "@/components/jessibuca/index.vue";
import model from './model';
import { treeselect } from "@/api/system/dept";
import { getSdpTerminalStatus, getWeather } from "@/api/device/device";
import usePermissionStore from "@/store/modules/permission";
import mqtt from "precompiled-mqtt";
import axios from "axios";
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const permissionStore = usePermissionStore();
    const {
      proxy
    } = getCurrentInstance();
    const {
      device_type,
      task_status,
      sys_task_type
    } = proxy.useDict("device_type", "task_status", "sys_task_type");
    const ids = ref([]); // 选中数组
    const arrDeptIds = ref([]); // 应急idList
    const title = ref("");
    const viewtitle = ref("任务详情");
    const multiple = ref(true); // 非多个禁用
    const showProvince = ref(false); // 非多个禁用
    const defaultSort = ref({
      prop: 'taskId',
      order: 'descending'
    }); // 默认排序
    const showSearch = ref(true); // 显示搜索条件
    const total = ref(0); // 总条数
    const timer = ref(undefined);
    const taskList = ref([]); // 表格数据
    const tableList = ref([]);
    const modelList = ref([]);
    const droneList = ref([]);
    const carList = ref([]);
    const userList = ref([]);
    const userListTask = ref([]);
    const pointList = ref([]);
    const pointIdOptions = ref([]);
    const childDeviceList = ref([]);
    const createTaskLabel = ref(false);
    const open = ref(false); // 是否显示弹出层
    const viewopen = ref(false); // 是否显示弹出层
    const dateRange = ref([]); // 日期范围
    const modelId = ref(undefined);
    const deptName = ref("");
    const deviceflat = ref({});
    const deptOptions = ref(undefined);
    const shareTitle = ref("分享");
    const shareOpen = ref(false);
    let a = Date.now();
    const client = mqtt.connect("wss://satwide.com/mqtt", {
      clientId: 'task' + a
    });
    client.on("connect", () => {
      console.log(`mqttTask连接成功`);
    });
    const defaultProps = ref({
      value: 'userId',
      label: 'label',
      children: 'children',
      disabled: function (data, node) {
        if (data.id) {
          return true;
        } else {
          return false;
        }
      }
    });
    const mqttPrefix = {
      flightData: 'sat_data_flight_',
      route: 'sat_data_route_',
      satcom: 'sat_data_satcom_'
    };
    const videoUrl = ref([{
      id: 0,
      name: "吊舱",
      url: ""
    }, {
      id: 1,
      name: "任务车",
      url: ""
    }, {
      id: 2,
      name: "时空服务中心",
      url: ""
    }, {
      id: 4,
      name: "数据连接",
      uid: "",
      position: [],
      flightData: ""
    }]);
    const flightMessage = reactive({
      status: false,
      isloading: true
    });
    const data = reactive({
      topics: [],
      form: {},
      shareform: {},
      viewform: {},
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        deptId: undefined,
        taskName: undefined,
        taskStatus: undefined,
        userIds: []
      },
      vedio: {
        // 是否显示弹出层
        open: false,
        // 弹出层标题
        title: '测试连接',
        // 上传的地址
        url: null
      },
      // 表单校验
      rules: {
        taskName: [{
          required: true,
          message: '任务名称不能为空',
          trigger: 'blur'
        }, {
          min: 2,
          max: 20,
          message: '任务名称长度必须介于 2 和 20 之间',
          trigger: 'blur'
        }],
        currdate: [{
          required: true,
          message: '日期不能为空',
          trigger: 'blur'
        }],
        taskTimes: [{
          required: true,
          message: '架次不能为空',
          trigger: 'blur'
        }],
        deptId: [{
          required: true,
          message: '归属部门不能为空',
          trigger: 'blur'
        }],
        userIds: [{
          required: true,
          message: '请选择任务人员',
          trigger: 'blur'
        }],
        aircraft: [{
          required: true,
          message: '请选择任务飞机',
          trigger: 'blur'
        }],
        areaName: [{
          required: true,
          message: '任务区域不能为空',
          trigger: 'blur'
        }],
        taskType: [{
          required: true,
          message: '请选择作业类型',
          trigger: 'blur'
        }],
        flightReasons: [{
          required: true,
          message: '飞行原因不能为空',
          trigger: 'blur'
        }]
      },
      messageInforules: {
        email: [{
          required: true,
          message: '邮箱不能为空',
          trigger: 'blur'
        }],
        taskName: [{
          required: true,
          message: '任务名称不能为空',
          trigger: 'blur'
        }],
        result: [{
          required: true,
          message: '飞行结论不能为空',
          trigger: 'blur'
        }],
        sign: [{
          required: true,
          message: '签字确认不能为空',
          trigger: 'blur'
        }]
      },
      shareformrules: {
        shareUserIds: [{
          required: true,
          message: '请选择用户',
          trigger: 'blur'
        }]
      }
    });
    const {
      queryParams,
      form,
      shareform,
      viewform,
      vedio,
      rules,
      messageInforules,
      shareformrules
    } = toRefs(data);

    /** 通过条件过滤节点  */
    const filterNode = (value, data) => {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    };
    /** 根据名称筛选部门树 */
    watch(deptName, val => {
      proxy.$refs["deptTreeRef"].filter(val);
    });

    /** 节点单击事件 */
    function handleNodeClick(data) {
      queryParams.value.deptId = data.id;
      handleQuery();
    }
    ;
    function toQuery(row) {
      console.log("跳转告警查询页面" + row.taskId + "||" + row.taskName);
      if (dateRange.value.length > 0) {
        queryParams.value.dateRange = dateRange.value;
      }
      permissionStore.setQueryParams(queryParams.value);
      router.push({
        path: '/alarm',
        state: {
          id: row.aircraft,
          type: row.deviceType,
          taskId: row.taskId,
          isTasking: row.taskStatus === 1 ? true : false
        }
      });
    }
    function toHome(row) {
      console.log("跳转到任务监控页面" + row.taskId);
      if (dateRange.value.length > 0) {
        queryParams.value.dateRange = dateRange.value;
      }
      permissionStore.setQueryParams(queryParams.value);
      router.push({
        path: '/task',
        state: {
          id: row.aircraft,
          type: row.deviceType,
          taskId: row.taskId,
          isTasking: row.taskStatus === 1 ? true : false
        }
      });
    }
    function changDroneList() {
      childDeviceList.value = [];
      console.log("关联载荷：", deviceflat.value);
      childDeviceList.value = deviceflat.value.childList;
      videoUrl.value[3].uid = deviceflat.value.uid;
      videoUrl.value[3].position = [deviceflat.value.longitude, deviceflat.value.latitude];
    }
    client.on("message", (topic, message) => {
      if (topic.includes(mqttPrefix.flightData)) {
        if (!flightMessage.status) {
          setTimeout(function () {
            videoUrl.value[3].flightData = message.toString();
            flightMessage.isloading = false;
            flightMessage.status = true;
          }, 3000);
        }
      }
    });
    function selectDept(value) {
      console.log("选中部门");
      console.log(value);
      let item = findItemById(value, arrDeptIds.value);
      if (item) {
        showProvince.value = true;
        form.value.province = item.label.replace("应急厅", "");
      } else {
        showProvince.value = false;
        form.value.province = undefined;
        form.value.city = undefined;
      }
    }
    function findItemById(id, arr) {
      for (const item of arr) {
        if (item.id === id) {
          return item; // 找到匹配的id，返回该项
        }
      }
      return null;
    }
    function getChildrenIds(parentId, data) {
      const ids = []; // 存储子项id的数组
      for (const item of data) {
        if (item.id === parentId) {
          // 如果找到匹配的父项，递归遍历其子项
          if (item.children) {
            item.children.forEach(child => {
              ids.push(child); // 将子项id添加到数组中
              const deeperIds = getChildrenIds(child.id, data); // 递归获取更深层次的子项id
              ids.push(...deeperIds); // 将更深层次的子项id添加到数组中
            });
          }
          break; // 找到匹配的父项后退出循环
        }
        if (item.children) {
          // 如果当前项有子项，递归查找
          const result = getChildrenIds(parentId, item.children);
          if (result.length > 0) {
            ids.push(...result); // 将找到的子项id添加到数组中
          }
        }
      }
      return ids; // 返回包含所有子项id的数组
    }
    function testRtsp() {
      //mqtt订阅uid查看飞行数据是否正常
      flightMessage.isloading = true;
      flightMessage.status = false;
      videoUrl.value = [{
        id: 0,
        name: "吊舱",
        url: ""
      }, {
        id: 1,
        name: "任务车",
        url: ""
      }, {
        id: 2,
        name: "时空服务中心",
        url: ""
      }, {
        id: 4,
        name: "数据连接",
        uid: "",
        position: [],
        flightData: ""
      }];
      changDroneList();
      let topic = mqttPrefix.flightData + videoUrl.value[3].uid;
      if (videoUrl.value[3].uid) {
        client.subscribe(topic, {
          qos: 2
        }, () => {
          console.log(`订阅了无人机主题 ${topic}`);
          console.log(client);
        });
      }
      createTaskLabel.value = true;
      childDeviceList.value.map(item => {
        if (item.deviceName) {
          if (item.channelId === undefined) {
            item.channelId = 0;
          }
          deviceVideoPlay({
            deviceName: item.deviceName,
            channelId: item.channelId,
            deviceType: item.deviceType
          }).then(res => {
            if (res.code === 200) {
              if (res.msg === '暂无推流信息') {
                return;
              } else if (res.msg === '操作成功') {
                if (item.deviceType === "5") {
                  videoUrl.value[0].url = res.data.https_flv;
                  viewform.value.videoSrc = res.data.https_flv;
                } else if (item.deviceType === "4") {
                  videoUrl.value[1].url = res.data.wss_flv;
                } else if (item.deviceType === "12") {
                  videoUrl.value[2].url = res.data.wss_flv;
                }
              }
            }
          });
        }
      });
      console.log("测试连接：", videoUrl.value);
      getWeatherInfo(videoUrl.value[3].position[0], videoUrl.value[3].position[1]);
      setTimeout(() => {
        if (videoUrl.value[3].flightData !== "") {
          flightMessage.isloading = false;
          flightMessage.status = true;
        } else {
          flightMessage.isloading = false;
          flightMessage.status = false;
        }
      }, 10000);
      vedio.value.open = true;
    }
    const showTerminal = () => {
      if (terminalId.value === '') {
        proxy.$modal.msgWarning("未设置卫星天线的端站点ID，请去设备管理页面设置");
      } else {
        getSdpTerminalStatus(terminalId.value).then(res => {
          if (res.code === 200) {
            pageData.terminalData = res.data;
            openData.value = true;
          } else {
            proxy.$modal.msgWarning("查询卫星天线信息失败，请检查端站点ID设置是否正确");
          }
          console.log(res);
        });
      }
    };

    // 关闭窗口
    function closeDialog() {
      client.unsubscribe(mqttPrefix.flightData + videoUrl.value[3].uid);
      vedio.value.open = false;
      videoUrl.value = [{
        id: 0,
        name: "吊舱",
        url: ""
      }, {
        id: 1,
        name: "任务车",
        url: ""
      }, {
        id: 2,
        name: "时空服务中心",
        url: ""
      }, {
        id: 4,
        name: "数据连接",
        uid: "",
        position: [],
        flight: ''
      }];
      flightMessage.isloading = true;
      flightMessage.status = false;
      weatherData.city = "";
      weatherData.date = "";
      weatherData.wea = "";
      weatherData.tem = "";
      weatherData.win = "";
      weatherData.win_speed = "";
      weatherData.win_meter = "";
      weatherData.humidity = "";
      weatherData.visibility = "";
      weatherData.rain_pcpn = "";
      console.log("关闭测试连接：", videoUrl.value);
    }
    function setDateRange(val) {
      dateRange.value = val;
      console.log(dateRange.value);
    }

    /** 查询列表 */
    function getList() {
      listTask(proxy.addDateRange(queryParams.value, dateRange.value, "task")).then(response => {
        taskList.value = response.rows;
        total.value = response.total;
        if (taskList.value.findIndex(tmp => tmp.taskStatus === 1) !== -1) {
          clearTimeout(timer.value); //清除延迟执行
          timer.value = setTimeout(() => {
            //设置延迟执行
            getList();
          }, 10000);
        }
      });
      getTaskList().then(response => {
        tableList.value = [];
        modelList.value = [];
        const data = response.data;
        if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            tableList.value.push({
              key: i,
              label: data[i].taskName,
              isModel: data[i].isModel,
              taskId: data[i].taskId
            });
            if (data[i].isModel === '1') {
              modelList.value.push(data[i]);
            }
          }
        }
      });
    }
    function taskTimesFormat(row) {
      var taskMonth = row.taskMonth < 10 ? "0" + row.taskMonth : row.taskMonth;
      var taskDay = row.taskDay < 10 ? "0" + row.taskDay : row.taskDay;
      return "" + row.taskYear + taskMonth + taskDay + '-' + row.taskTimes;
    }

    // 取消按钮
    function cancel() {
      open.value = false;
      modelId.value = undefined;
      reset();
    }
    function toTasking(row) {
      getTask(row.taskId).then(response => {
        viewform.value = response.data;
        deviceflat.value = response.deviceflat;
        changDroneList();
        viewopen.value = true;
      });
    }
    function viewCancel() {
      viewopen.value = false;
      createTaskLabel.value = false;
      resetview();
    }
    function resetview() {
      viewform.value = {};
      deviceflat.value = {};
      proxy.resetForm('viewformRef');
    }

    // 表单重置
    function reset() {
      form.value = {
        taskName: undefined,
        taskTypeChild: "0",
        areaName: undefined,
        deptId: undefined,
        currdate: new Date(),
        //日期
        taskTimes: undefined,
        //架次
        areaElevation: undefined,
        //测区高程
        flightDistance: undefined,
        //飞行距离
        aircraft: undefined,
        //任务飞机
        car: undefined,
        //任务车
        videoSrc: undefined,
        //设备吊舱视频
        userIds: undefined,
        taskType: undefined,
        flightReasons: undefined,
        remark: undefined
      };
      showProvince.value = false;
      proxy.resetForm('taskManagerRef');
    }

    /** 搜索按钮操作 */
    function handleQuery() {
      queryParams.value.pageNum = 1;
      getList();
    }

    /** 重置按钮操作 */
    function resetQuery() {
      dateRange.value = [];
      proxy.$refs["datePickerRef"].reset();
      queryParams.value.pageNum = 1;
      queryParams.value.pageSize = 10;
      queryParams.value.deptId = undefined;
      queryParams.value.taskName = undefined;
      queryParams.value.taskStatus = undefined;
      permissionStore.queryParams = undefined;
      handleQuery();
    }

    // 多选框选中数据
    function handleSelectionChange(selection) {
      ids.value = selection.map(item => item.taskId);
      multiple.value = !selection.length;
    }

    /** 新增按钮操作 */
    function handleAdd() {
      reset();
      open.value = true;
      title.value = '添加任务';
    }

    /** 修改按钮操作 */
    function handleUpdate(row) {
      reset();
      getTask(row.taskId).then(response => {
        form.value = response.data;
        form.value.currdate = new Date(form.value.taskYear, form.value.taskMonth - 1, form.value.taskDay);
        let item = findItemById(form.value.deptId, arrDeptIds.value);
        if (item) {
          showProvince.value = true;
          if (!form.value.province) {
            form.value.province = item.label.replace("应急厅", "");
          }
        } else {
          showProvince.value = false;
          form.value.province = undefined;
          form.value.city = undefined;
        }
        open.value = true;
        title.value = "修改任务";
      });
    }
    ;

    /** 提交按钮 */
    function submitForm() {
      var date = form.value.currdate;
      form.value.taskYear = date.getFullYear();
      var month = date.getMonth() + 1;
      form.value.taskMonth = month < 10 ? "0" + month : month;
      form.value.taskDay = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      proxy.$refs["taskManagerRef"].validate(valid => {
        if (valid) {
          if (form.value.taskId != undefined) {
            updateTask(form.value).then(response => {
              if (response.code === 500) {
                proxy.$modal.msgWarning(response.msg);
              } else {
                proxy.$modal.msgSuccess("修改成功");
              }
              cancel();
              getList();
            });
          } else {
            addTask(form.value).then(response => {
              proxy.$modal.msgSuccess("新增成功");
              cancel();
              getList();
            });
          }
        }
      });
    }
    function startTasking() {
      if (!createTaskLabel.value) {
        proxy.$modal.confirmX('请先进行链路测试!!!', "系统提示", {
          showClose: false
        });
        return;
      }
      /*if (viewform.value.videoSrc === null || viewform.value.videoSrc === undefined || viewform.value.videoSrc === "") {
        proxy.$modal.msgWarning('吊舱视频流地址不能为空!!!');
        return;
      }*/
      getTaskingCountEnough(viewform.value).then(response => {
        if (response.data === true) {
          proxy.$modal.msgWarning("执行中的任务数量不能超过3个,请稍后执行或提前结束其他任务");
          return;
        } else {
          if (response.deviceflat && deviceflat.value) {
            let changed = false;
            const air = response.deviceflat;
            if (air.id !== deviceflat.value.id || air.uid !== deviceflat.value.uid) {
              changed = true;
            }
            air.childList.forEach(item => {
              deviceflat.value.childList.forEach(tmp => {
                if (item.deviceType === tmp.deviceType && (item.deviceType === '4' || item.deviceType === '5')) {
                  if (item.id !== tmp.id || item.deviceName !== tmp.deviceName || item.channelId !== tmp.channelId) {
                    changed = true;
                  }
                }
                if (item.deviceType === tmp.deviceType && item.deviceType === '6') {
                  if (item.id !== tmp.id) {
                    changed = true;
                  }
                  const fieldTemplateList1 = item.fieldTemplateList;
                  const fieldTemplateList2 = item.fieldTemplateList;
                  fieldTemplateList1.forEach(item1 => {
                    fieldTemplateList2.forEach(tmp1 => {
                      if (item1.field === tmp1.field && item1.field === "terminalId") {
                        if (item1.value !== tmp1.value) {
                          changed = true;
                        }
                      }
                    });
                  });
                }
              });
            });
            if (changed) {
              proxy.$modal.msgWarning("任务关联设备发生变化，请确认设备信息");
              viewCancel();
              return;
            }
          }
          startTask(viewform.value).then(response => {
            if (response.code === 500) {
              proxy.$modal.msgWarning(response.msg);
            } else {
              proxy.$modal.msgSuccess("任务已开始执行");
            }
            viewCancel();
            getList();
          });
        }
      });
    }

    /** 删除按钮操作 */
    function handleDelete(row) {
      const taskIds = row.taskId || ids.value;
      const names = proxy.getNames(taskIds, taskList.value, "taskId", "taskName");
      proxy.$modal.confirm("是否确认删除任务名称为\"" + names + "\"的数据项？").then(function () {
        return delTask(taskIds);
      }).then(() => {
        getList();
        proxy.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    }
    function showUser(row) {
      getUsersByTaskId({
        "taskId": row.taskId
      }).then(res => {
        if (res.data.taskUsers) {
          let taskUsers = JSON.parse(res.data.taskUsers);
          userOpen.value = true;
          userListTask.value = taskUsers;
        } else {
          proxy.$modal.notify("直升机任务没有人员设置");
        }
      });
    }
    /** 停止任务 */
    function handleStop(row) {
      const taskId = row.taskId;
      const names = proxy.getNames(taskId, taskList.value, "taskId", "taskName");
      proxy.$modal.confirm("是否确认停止任务名称为\"" + names + "\"的数据项？").then(function () {
        return stopTaskById(row);
      }).then(() => {
        getList();
        proxy.$modal.msgSuccess("任务停止成功");
      }).catch(() => {});
    }
    function getmodelshow() {
      proxy.$refs["modelRef"].show();
    }
    function setModelData() {
      if (modelId.value !== undefined) {
        modelList.value.map(item => {
          if (item.taskId === modelId.value) {
            reset();
            form.value.taskName = item.taskName;
            form.value.deptId = item.deptId;
            form.value.aircraft = item.aircraft;
            form.value.car = item.car;
            form.value.taskTimes = item.taskTimes;
            form.value.areaName = item.areaName;
            form.value.taskType = item.taskType;
            form.value.flightReasons = item.flightReasons;
          }
        });
        getTask(modelId.value).then(response => {
          form.value.userIds = [];
          form.value.userIds = response.data.userIds;
        });
      }
    }
    if (permissionStore.queryParams !== undefined) {
      if (permissionStore.queryParams.pageSize !== undefined) {
        queryParams.value = permissionStore.queryParams;
      }
      if (permissionStore.queryParams.dateRange !== undefined) {
        dateRange.value = permissionStore.queryParams.dateRange;
        setTimeout(() => {
          proxy.$refs["datePickerRef"].history(dateRange.value);
        }, 50);
      }
    }
    onUnmounted(() => {
      client.end(true, {}, () => {
        console.log("关闭mqttclient");
      });
    });
    onMounted(() => {
      getList();
      treeselect().then(response => {
        deptOptions.value = response.data;
        arrDeptIds.value = getChildrenIds(151, deptOptions.value);
        console.log("应急部门id", arrDeptIds.value);
      });
      //不用上云API直接去库了查设备
      getTreeselectDeviceList({
        type: "air"
      }).then(response => {
        droneList.value = response.data;
      });
      getTreeselectDeviceList({
        type: "car"
      }).then(response => {
        carList.value = response.data;
      });
      getTreeselectUserList().then(response => {
        userList.value = response.data;
      });
      getPointList().then(response => {
        pointList.value = response.data;
      });
    });
    function getLabel(type) {
      return proxy.selectDictLabel(device_type.value, type);
    }
    const weatherData = reactive({
      //地名(小地名)
      city: "",
      //时间
      date: "",
      //实时天气情况
      wea: "",
      //实时温度
      tem: "",
      //风向
      win: "",
      //风力等级
      win_speed: "",
      //风速 km/h
      win_meter: "",
      //湿度
      humidity: "",
      //能见度
      visibility: "",
      //降雨量
      rain_pcpn: ""
    });
    function getWeatherInfo(lng, lat) {
      if (lng === undefined || lat === undefined) {
        return;
      }
      getWeather({
        longitude: lng,
        latitude: lat
      }).then(result => {
        if (result.code === 200 && result.data.errcode === 0) {
          console.log("天气数据返回值");
          console.log(result);
          weatherData.city = result.data.leader + "·" + result.data.city;
          weatherData.date = result.data.updateTimeFormat;
          weatherData.wea = result.data.hours[0].wea;
          weatherData.tem = result.data.hours[0].tem + "°C";
          weatherData.win = result.data.hours[0].wind;
          weatherData.win_speed = result.data.hours[0].windLevel;
          weatherData.win_meter = result.data.hours[0].windSpeed + 'km/h';
          weatherData.humidity = result.data.hours[0].humidity;
          weatherData.visibility = result.data.hours[0].visibility;
          weatherData.rain_pcpn = result.data.hours[0].rain_pcpn + "mm";
          viewform.value.wea = result.data.hours[0].wea;
          viewform.value.winMeter = result.data.hours[0].windLevel;
          viewform.value.win = result.data.hours[0].wind;
        }
      });
    }
    ;
    const filterNodeMethod = (value, data) => data.label.includes(value);
    const messageInfo = ref({});
    const alarmList = ref([]);
    const messageOpen = ref(false);
    const userOpen = ref(false);
    function sendMessage(row) {
      getMessageInfo(row.taskId).then(response => {
        messageInfo.value = response.data;
        messageInfo.value.flighttimes = messageInfo.value.flightStarttime + '~' + messageInfo.value.flightEndtime;
        messageInfo.value.flighttime = proxy.getTime(messageInfo.value.taskDuration);
        resetAlarmList();
        messageOpen.value = true;
      });
    }
    const getAlarmInfoListByPointIdList = () => {
      let options = [];
      let queryParams = {};
      if (pointIdOptions.value.length > 0) {
        for (let pointIdListElement of pointIdOptions.value) {
          options.push(pointIdListElement[pointIdListElement.length - 1]);
        }
      }
      queryParams.taskId = messageInfo.value.taskId;
      queryParams.reportNoList = options;
      queryParams.pageNum = 1;
      queryParams.pageSize = 1000;
      queryParams.selectLabel = 1;
      alarmList.value = [];
      getAlarmList(queryParams).then(res => {
        alarmList.value = res.rows;
      });
    };
    function resetAlarmList() {
      pointIdOptions.value = [];
      getAlarmInfoListByPointIdList();
    }
    function delImg(url) {
      alarmList.value.forEach(item => {
        if (item.recognitionUrl === url) {
          item.delete = true;
        }
        return item;
      });
    }
    function sendEmailMessage() {
      messageInfo.value.alarmList = alarmList.value;
      console.log(messageInfo.value);
      proxy.$refs["messageInfoRef"].validate(valid => {
        if (valid) {
          sendEmail(messageInfo.value).then(response => {
            proxy.$modal.msgSuccess("邮件已发送");
            emailMessageClose();
          });
        }
      });
    }
    function emailMessageClose() {
      messageInfo.value = {};
      alarmList.value = [];
      messageOpen.value = false;
    }
    function OnSubscribe() {
      //邮箱验证的正则表达式
      const reg = /([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      let str = messageInfo.value.email;
      if (str === undefined || str === null) return;
      const emails = str.split(',').map(email => email.trim());
      for (let i = 0; i < emails.length; i++) {
        if (emails[i] && !reg.test(emails[i])) {
          proxy.$modal.msgWarning("邮箱格式错误");
          return;
        }
      }
    }
    function handleShare(row) {
      shareform.value.taskId = row.taskId;
      shareOpen.value = true;
    }
    function shareSubmit() {
      proxy.$refs["taskShareRef"].validate(valid => {
        if (valid) {
          shareTask(shareform.value).then(response => {
            if (response.code === 200) {
              proxy.$modal.msgSuccess(response.msg);
            } else {
              proxy.$modal.msgError(response.msg);
            }
            shareCancel();
          });
        }
      });
    }
    function shareCancel() {
      shareform.value = {};
      shareOpen.value = false;
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_tree = _resolveComponent("el-tree");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_tree_select = _resolveComponent("el-tree-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_right_toolbar = __unplugin_components_0;
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_progress = _resolveComponent("el-progress");
      const _component_dict_tag = __unplugin_components_1;
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_table = _resolveComponent("el-table");
      const _component_pagination = __unplugin_components_2;
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_tree_select = __unplugin_components_3;
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_dot = _resolveComponent("dot");
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_image = _resolveComponent("el-image");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 4,
          xs: 24
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input, {
            modelValue: _unref(deptName),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(deptName) ? deptName.value = $event : null),
            clearable: "",
            placeholder: "请输入部门名称",
            "prefix-icon": "Search",
            style: {
              "margin-bottom": "2rem"
            }
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_tree, {
            ref: "deptTreeRef",
            data: _unref(deptOptions),
            "expand-on-click-node": false,
            "filter-node-method": filterNode,
            props: {
              label: 'label',
              children: 'children'
            },
            "default-expand-all": "",
            "highlight-current": "",
            onNodeClick: handleNodeClick
          }, null, 8, ["data"])])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 20,
          xs: 24
        }, {
          default: _withCtx(() => [_withDirectives(_createVNode(_component_el_form, {
            model: _unref(queryParams),
            ref: "queryRef",
            inline: true
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "任务时间",
              style: {
                "width": "41rem"
              }
            }, {
              default: _withCtx(() => [_createVNode(_unref(DatePicker), {
                ref: "datePickerRef",
                onSetDateRange: setDateRange
              }, null, 512)]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "任务名称",
              prop: "taskName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(queryParams).taskName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(queryParams).taskName = $event),
                placeholder: "请输入任务名称",
                clearable: "",
                style: {
                  "width": "18rem"
                },
                onKeyup: _withKeys(handleQuery, ["enter"])
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "状态",
              prop: "taskStatus"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(queryParams).taskStatus,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(queryParams).taskStatus = $event),
                placeholder: "状态",
                clearable: "",
                style: {
                  "width": "18rem"
                }
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(task_status), dict => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: dict.value,
                    label: dict.label,
                    value: dict.value
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "任务人员",
              prop: "userIds"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_tree_select, {
                modelValue: _unref(queryParams).userIds,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(queryParams).userIds = $event),
                data: _unref(userList),
                multiple: "",
                props: _unref(defaultProps),
                "collapse-tags": "",
                "collapse-tags-tooltip": "",
                "default-expand-all": "",
                "filter-node-method": filterNodeMethod,
                filterable: "",
                clearable: "",
                placeholder: "请选择"
              }, null, 8, ["modelValue", "data", "props"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                icon: "Search",
                class: "satpro-button",
                onClick: handleQuery
              }, {
                default: _withCtx(() => [...(_cache[53] || (_cache[53] = [_createTextVNode("搜索", -1)]))]),
                _: 1
              }), _createVNode(_component_el_button, {
                icon: "Refresh",
                class: "satpro-button",
                onClick: resetQuery
              }, {
                default: _withCtx(() => [...(_cache[54] || (_cache[54] = [_createTextVNode("重置", -1)]))]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"]), [[_vShow, _unref(showSearch)]]), _createVNode(_component_el_row, {
            gutter: 10,
            class: "mb8"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 1.5
            }, {
              default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
                icon: "Plus",
                plain: "",
                class: "satpro-button",
                onClick: handleAdd
              }, {
                default: _withCtx(() => [...(_cache[55] || (_cache[55] = [_createTextVNode("新增任务 ", -1)]))]),
                _: 1
              })), [[_directive_hasPermi, ['drone:task:add']]])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 1.5
            }, {
              default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
                disabled: _unref(multiple),
                icon: "Delete",
                plain: "",
                class: "satpro-button",
                onClick: handleDelete
              }, {
                default: _withCtx(() => [...(_cache[56] || (_cache[56] = [_createTextVNode("删除 ", -1)]))]),
                _: 1
              }, 8, ["disabled"])), [[_directive_hasPermi, ['drone:task:remove']]])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 1.5
            }, {
              default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
                plain: "",
                class: "satpro-button",
                onClick: getmodelshow
              }, {
                default: _withCtx(() => [...(_cache[57] || (_cache[57] = [_createTextVNode("模板数据 ", -1)]))]),
                _: 1
              })), [[_directive_hasPermi, ['drone:task:list']]])]),
              _: 1
            }), _createVNode(_unref(model), {
              tableList: _unref(tableList),
              ref: "modelRef",
              onUploadTableList: getList
            }, null, 8, ["tableList"]), _createVNode(_component_right_toolbar, {
              showSearch: _unref(showSearch),
              "onUpdate:showSearch": _cache[4] || (_cache[4] = $event => _isRef(showSearch) ? showSearch.value = $event : null),
              onQueryTable: getList
            }, null, 8, ["showSearch"])]),
            _: 1
          }), _cache[58] || (_cache[58] = _createElementVNode("div", {
            class: "menu-name"
          }, [_createElementVNode("span", {
            class: "textinfo"
          }, "任务管理")], -1)), _createVNode(_component_el_table, {
            data: _unref(taskList),
            "default-sort": _unref(defaultSort),
            onSelectionChange: handleSelectionChange,
            "header-cell-style": {
              background: 'transparent !important',
              color: '#FFFFFF'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              type: "selection",
              width: "50",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              label: "编号",
              align: "center",
              key: "taskId",
              prop: "taskId"
            }), _createVNode(_component_el_table_column, {
              label: "名称",
              align: "center",
              key: "taskName",
              prop: "taskName",
              "show-overflow-tooltip": true
            }), _createVNode(_component_el_table_column, {
              label: "部门",
              align: "center",
              key: "deptName",
              prop: "deptName",
              "show-overflow-tooltip": true
            }), _createVNode(_component_el_table_column, {
              label: "架次",
              align: "center",
              key: "taskTimes",
              prop: "taskTimes",
              formatter: taskTimesFormat
            }), _createVNode(_component_el_table_column, {
              label: "开始时间",
              align: "center",
              prop: "taskStarttime",
              width: "100"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_ctx.parseTime(scope.row.taskStarttime, '{h}:{i}:{s}')), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "结束时间",
              align: "center",
              prop: "taskEndtime",
              width: "100"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_ctx.parseTime(scope.row.taskEndtime, '{h}:{i}:{s}')), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "进度",
              align: "center",
              prop: "percentage",
              width: "180"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_progress, {
                "text-inside": true,
                "stroke-width": 24,
                percentage: scope.row.percentage,
                status: "success"
              }, null, 8, ["percentage"])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "时长",
              align: "center",
              prop: "taskDuration",
              width: "90"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.taskDuration === undefined ? "" : _ctx.getTime(scope.row.taskDuration)), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "状态",
              align: "center",
              key: "taskStatus"
            }, {
              default: _withCtx(scope => [_createVNode(_component_dict_tag, {
                options: _unref(task_status),
                value: scope.row.taskStatus
              }, null, 8, ["options", "value"])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "操作",
              align: "center",
              width: "200",
              "class-name": "small-padding fixed-width"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_tooltip, {
                content: "修改",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  icon: "Edit",
                  type: "primary",
                  link: "",
                  onClick: $event => handleUpdate(scope.row)
                }, null, 8, ["onClick"]), [[_directive_hasPermi, ['drone:task:edit']], [_vShow, scope.row.taskStatus == 0]])]),
                _: 2
              }, 1024), _createVNode(_component_el_tooltip, {
                content: "开始任务",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  icon: "VideoPlay",
                  type: "primary",
                  link: "",
                  onClick: $event => toTasking(scope.row)
                }, null, 8, ["onClick"]), [[_directive_hasPermi, ['drone:task:start']], [_vShow, scope.row.taskStatus == 0]])]),
                _: 2
              }, 1024), _createVNode(_component_el_tooltip, {
                content: "查看任务",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  icon: "VideoPlay",
                  type: "primary",
                  link: "",
                  onClick: $event => toHome(scope.row)
                }, null, 8, ["onClick"]), [[_vShow, scope.row.taskStatus === 1]])]),
                _: 2
              }, 1024), _createVNode(_component_el_tooltip, {
                content: "任务回放",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  icon: "VideoCameraFilled",
                  type: "primary",
                  link: "",
                  onClick: $event => toHome(scope.row)
                }, null, 8, ["onClick"]), [[_vShow, scope.row.taskStatus === 2 && scope.row.videoSource]])]),
                _: 2
              }, 1024), _createVNode(_component_el_tooltip, {
                content: "无任务回放",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  style: {
                    "color": "#ce9394"
                  },
                  icon: "Warning",
                  type: "primary",
                  link: ""
                }, null, 512), [[_vShow, scope.row.taskStatus === 2 && !scope.row.videoSource && scope.row.endMin > 15]])]),
                _: 2
              }, 1024), _createVNode(_component_el_tooltip, {
                content: "正在生成回放",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  style: {
                    "color": "#74c54d"
                  },
                  icon: "Clock",
                  type: "primary",
                  link: ""
                }, null, 512), [[_vShow, scope.row.taskStatus === 2 && !scope.row.videoSource && scope.row.endMin <= 15]])]),
                _: 2
              }, 1024), _createVNode(_component_el_tooltip, {
                content: "停止任务",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  icon: "SwitchButton",
                  type: "primary",
                  link: "",
                  onClick: $event => handleStop(scope.row)
                }, null, 8, ["onClick"]), [[_directive_hasPermi, ['drone:task:stop']], [_vShow, scope.row.taskStatus == 1]])]),
                _: 2
              }, 1024), _createVNode(_component_el_tooltip, {
                content: "任务人员",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  icon: "User",
                  type: "primary",
                  link: "",
                  onClick: $event => showUser(scope.row)
                }, null, 8, ["onClick"])]),
                _: 2
              }, 1024), _createVNode(_component_el_tooltip, {
                content: "分享",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  icon: "Share",
                  type: "primary",
                  link: "",
                  onClick: $event => handleShare(scope.row)
                }, null, 8, ["onClick"]), [[_directive_hasPermi, ['drone:task:share']], [_vShow, scope.row.taskStatus == 1]])]),
                _: 2
              }, 1024), _createVNode(_component_el_tooltip, {
                content: "发送邮件",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  icon: "Message",
                  type: "primary",
                  link: "",
                  onClick: $event => sendMessage(scope.row)
                }, null, 8, ["onClick"]), [[_vShow, scope.row.taskStatus === 2 && scope.row.deviceType === '0']])]),
                _: 2
              }, 1024), _createVNode(_component_el_tooltip, {
                content: "删除",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  icon: "Delete",
                  type: "primary",
                  link: "",
                  onClick: $event => handleDelete(scope.row)
                }, null, 8, ["onClick"]), [[_directive_hasPermi, ['drone:task:remove']], [_vShow, scope.row.taskStatus !== 1]])]),
                _: 2
              }, 1024)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data", "default-sort"]), _withDirectives(_createVNode(_component_pagination, {
            total: _unref(total),
            limit: _unref(queryParams).pageSize,
            "onUpdate:limit": _cache[5] || (_cache[5] = $event => _unref(queryParams).pageSize = $event),
            page: _unref(queryParams).pageNum,
            "onUpdate:page": _cache[6] || (_cache[6] = $event => _unref(queryParams).pageNum = $event),
            onPagination: getList
          }, null, 8, ["total", "limit", "page"]), [[_vShow, _unref(total) > 0]])]),
          _: 1
        })]),
        _: 1
      }), _unref(open) ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 0,
        title: _unref(title),
        modelValue: _unref(open),
        "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => _isRef(open) ? open.value = $event : null),
        width: "70rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        "align-center": "",
        draggable: ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitForm
        }, {
          default: _withCtx(() => [...(_cache[59] || (_cache[59] = [_createTextVNode("确 认", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: cancel
        }, {
          default: _withCtx(() => [...(_cache[60] || (_cache[60] = [_createTextVNode("取 消", -1)]))]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref: "taskManagerRef",
          model: _unref(form),
          rules: _unref(rules),
          "label-width": "14rem"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "模板数据"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(modelId),
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _isRef(modelId) ? modelId.value = $event : null),
                  placeholder: "模板数据",
                  clearable: "",
                  onChange: setModelData
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modelList), dict => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: dict.taskId,
                      label: dict.taskName,
                      value: dict.taskId
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "名称",
                prop: "taskName"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).taskName,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _unref(form).taskName = $event),
                  placeholder: "请输入任务名称",
                  maxlength: "30",
                  clearable: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "归属部门",
                prop: "deptId"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tree_select, {
                  modelValue: _unref(form).deptId,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(form).deptId = $event),
                  data: _unref(deptOptions),
                  props: {
                    value: 'id',
                    label: 'label',
                    children: 'children'
                  },
                  "check-strictly": "",
                  clearable: "",
                  placeholder: "请选择归属部门",
                  "value-key": "id",
                  onChange: selectDept
                }, null, 8, ["modelValue", "data"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "日期",
                prop: "currdate"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  modelValue: _unref(form).currdate,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(form).currdate = $event),
                  type: "date",
                  placeholder: "选择日期"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "架次",
                prop: "taskTimes"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input_number, {
                  modelValue: _unref(form).taskTimes,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(form).taskTimes = $event),
                  placeholder: "请输入架次",
                  maxlength: "5",
                  min: 0,
                  precision: 0,
                  step: 1,
                  "controls-position": "right"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "任务人员",
                prop: "userIds"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tree_select, {
                  modelValue: _unref(form).userIds,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _unref(form).userIds = $event),
                  data: _unref(userList),
                  multiple: "",
                  props: _unref(defaultProps),
                  "collapse-tags": "",
                  "collapse-tags-tooltip": "",
                  "default-expand-all": "",
                  "filter-node-method": filterNodeMethod,
                  filterable: "",
                  clearable: "",
                  placeholder: "请选择"
                }, null, 8, ["modelValue", "data", "props"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "任务飞机",
                prop: "aircraft",
                disabled: ""
              }, {
                default: _withCtx(() => [_createVNode(_component_tree_select, {
                  value: _unref(form).aircraft,
                  "onUpdate:value": _cache[13] || (_cache[13] = $event => _unref(form).aircraft = $event),
                  options: _unref(droneList),
                  objMap: {
                    value: 'deviceId',
                    label: 'label',
                    children: 'children'
                  },
                  placeholder: "请选择"
                }, null, 8, ["value", "options"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "任务车",
                prop: "car"
              }, {
                default: _withCtx(() => [_createVNode(_component_tree_select, {
                  value: _unref(form).car,
                  "onUpdate:value": _cache[14] || (_cache[14] = $event => _unref(form).car = $event),
                  options: _unref(carList),
                  objMap: {
                    value: 'deviceId',
                    label: 'label',
                    children: 'children'
                  },
                  placeholder: "请选择"
                }, null, 8, ["value", "options"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "任务区域",
                prop: "areaName"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).areaName,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => _unref(form).areaName = $event),
                  placeholder: "请输入任务区域",
                  maxlength: "30",
                  clearable: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "作业类型",
                prop: "taskType"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(form).taskType,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => _unref(form).taskType = $event),
                  placeholder: "请选择",
                  clearable: ""
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sys_task_type), dict => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: dict.value,
                      label: dict.label,
                      value: dict.value
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _unref(showProvince) ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "任务省份",
                prop: "province"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).province,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => _unref(form).province = $event),
                  placeholder: "请输入任务所在省份",
                  maxlength: "30",
                  clearable: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "任务市",
                prop: "city"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).city,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => _unref(form).city = $event),
                  placeholder: "请输入任务所在市",
                  maxlength: "30",
                  clearable: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "飞行原因",
                prop: "flightReasons"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).flightReasons,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => _unref(form).flightReasons = $event),
                  type: "textarea",
                  placeholder: "请输入内容"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "备注",
                prop: "remark"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).remark,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => _unref(form).remark = $event),
                  type: "textarea",
                  placeholder: "请输入内容"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["title", "modelValue"])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        title: _unref(viewtitle),
        modelValue: _unref(viewopen),
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => _isRef(viewopen) ? viewopen.value = $event : null),
        width: "70rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        "align-center": "",
        draggable: ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: testRtsp
        }, {
          default: _withCtx(() => [...(_cache[61] || (_cache[61] = [_createTextVNode("测试连接", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: startTasking
        }, {
          default: _withCtx(() => [...(_cache[62] || (_cache[62] = [_createTextVNode("启动任务", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: viewCancel
        }, {
          default: _withCtx(() => [...(_cache[63] || (_cache[63] = [_createTextVNode("取 消", -1)]))]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref: "viewformRef",
          model: _unref(viewform),
          "label-width": "14rem"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "名称",
                prop: "taskName"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(viewform).taskName), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "归属部门",
                prop: "deptName"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(viewform).deptName), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "日期",
                prop: "currdate"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(viewform).taskYear + "-" + _unref(viewform).taskMonth + "-" + _unref(viewform).taskDay), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "架次",
                prop: "taskTimes"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(viewform).taskTimes), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "任务飞机",
                prop: "aircraft"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(deviceflat).name), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "任务人员",
                prop: "userIds"
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  style: {
                    "width": "18rem",
                    "overflow": "hidden",
                    "text-overflow": "ellipsis",
                    "white-space": "nowrap"
                  },
                  class: "title",
                  title: _unref(viewform).userNames
                }, _toDisplayString(_unref(viewform).userNames), 9, _hoisted_7)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "作业区域",
                prop: "areaName"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(viewform).areaName), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "作业类型",
                prop: "taskType"
              }, {
                default: _withCtx(() => [_createVNode(_component_dict_tag, {
                  options: _unref(sys_task_type),
                  value: _unref(viewform).taskType
                }, null, 8, ["options", "value"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _unref(childDeviceList) && _unref(childDeviceList).length > 0 ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(childDeviceList), item => {
              return _openBlock(), _createBlock(_component_el_col, {
                key: item.id,
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: getLabel(item.deviceType)
                }, {
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.name), 1)]),
                  _: 2
                }, 1032, ["label"])]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "飞行原因",
                prop: "flightReasons"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(viewform).flightReasons), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "备注",
                prop: "remark"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(viewform).remark), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["title", "modelValue"]), _createVNode(_component_el_dialog, {
        title: _unref(vedio).title,
        modelValue: _unref(vedio).open,
        "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => _unref(vedio).open = $event),
        width: "80rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        onBeforeClose: _cache[25] || (_cache[25] = $event => closeDialog())
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, i => {
          return _createElementVNode("div", {
            key: i,
            class: "play-box"
          }, [!_unref(videoUrl)[i - 1].url ? (_openBlock(), _createElementBlock("div", _hoisted_10, [i !== 4 ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(videoUrl)[i - 1].name) + "视频异常 ", 1)) : _createCommentVNode("", true), i === 4 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("table", _hoisted_14, [_createElementVNode("tbody", null, [_createElementVNode("tr", null, [_createElementVNode("td", _hoisted_15, [_createElementVNode("div", _hoisted_16, "地名: " + _toDisplayString(_unref(weatherData).city), 1)])]), _createElementVNode("tr", null, [_createElementVNode("td", _hoisted_17, [_createElementVNode("div", _hoisted_18, "更新时间: " + _toDisplayString(_unref(weatherData).date), 1)])]), _createElementVNode("tr", null, [_createElementVNode("td", _hoisted_19, [_createElementVNode("div", _hoisted_20, "实时天气情况: " + _toDisplayString(_unref(weatherData).wea), 1)]), _createElementVNode("td", _hoisted_21, [_createElementVNode("div", _hoisted_22, "实时温度: " + _toDisplayString(_unref(weatherData).tem), 1)])]), _createElementVNode("tr", null, [_createElementVNode("td", _hoisted_23, [_createElementVNode("div", _hoisted_24, "风向: " + _toDisplayString(_unref(weatherData).win), 1)]), _createElementVNode("td", _hoisted_25, [_createElementVNode("div", _hoisted_26, "风力等级: " + _toDisplayString(_unref(weatherData).win_speed), 1)])]), _createElementVNode("tr", null, [_createElementVNode("td", _hoisted_27, [_createElementVNode("div", _hoisted_28, "风速: " + _toDisplayString(_unref(weatherData).win_meter), 1)]), _createElementVNode("td", _hoisted_29, [_createElementVNode("div", _hoisted_30, "湿度: " + _toDisplayString(_unref(weatherData).humidity), 1)])]), _createElementVNode("tr", null, [_createElementVNode("td", _hoisted_31, [_createElementVNode("div", _hoisted_32, "能见度: " + _toDisplayString(_unref(weatherData).visibility), 1)]), _createElementVNode("td", _hoisted_33, [_createElementVNode("div", _hoisted_34, "降雨量: " + _toDisplayString(_unref(weatherData).rain_pcpn), 1)])])])])]), _createElementVNode("div", _hoisted_35, [_unref(flightMessage).isloading && _unref(flightMessage).status === false && _unref(videoUrl)[3].flightData === '' ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_cache[65] || (_cache[65] = _createTextVNode("飞控数据连接中 ", -1)), _createVNode(_component_dot, null, {
            default: _withCtx(() => [...(_cache[64] || (_cache[64] = [_createTextVNode("。。。", -1)]))]),
            _: 1
          })])) : _createCommentVNode("", true), !_unref(flightMessage).isloading && _unref(flightMessage).status === true && _unref(videoUrl)[3].flightData !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_37, "飞控链路正常 ")) : _createCommentVNode("", true), !_unref(flightMessage).isloading && _unref(flightMessage).status === false && _unref(videoUrl)[3].flightData === '' ? (_openBlock(), _createElementBlock("div", _hoisted_38, "飞控链路异常 ")) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)])) : (_openBlock(), _createBlock(player, {
            key: 1,
            ref_for: true,
            ref: "playerRef",
            url: _unref(videoUrl)[i - 1].url,
            fluent: "",
            autoplay: ""
          }, null, 8, ["url"])), _createElementVNode("div", _hoisted_39, _toDisplayString(_unref(videoUrl)[i - 1].name), 1)]);
        }), 64))]), _createElementVNode("div", _hoisted_40, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[23] || (_cache[23] = $event => closeDialog())
        }, {
          default: _withCtx(() => [...(_cache[66] || (_cache[66] = [_createTextVNode("确定", -1)]))]),
          _: 1
        })])]),
        _: 1
      }, 8, ["title", "modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(userOpen),
        "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => _isRef(userOpen) ? userOpen.value = $event : null)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: _unref(userListTask),
          "header-cell-style": {
            background: 'transparent !important',
            color: '#FFFFFF'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "人员",
            align: "center",
            key: "userName",
            prop: "userName"
          }), _createVNode(_component_el_table_column, {
            label: "岗位",
            align: "center",
            key: "postName",
            prop: "postName",
            "show-overflow-tooltip": true
          }), _createVNode(_component_el_table_column, {
            label: "部门",
            align: "center",
            key: "deptName",
            prop: "deptName"
          }), _createVNode(_component_el_table_column, {
            label: "手机号码",
            align: "center",
            key: "phonenumber",
            prop: "phonenumber"
          }), _createVNode(_component_el_table_column, {
            label: "邮箱",
            align: "center",
            key: "email",
            prop: "email"
          })]),
          _: 1
        }, 8, ["data"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        title: "邮件发送",
        modelValue: _unref(messageOpen),
        "onUpdate:modelValue": _cache[49] || (_cache[49] = $event => _isRef(messageOpen) ? messageOpen.value = $event : null),
        width: "74rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        "align-center": "",
        onBeforeClose: _cache[50] || (_cache[50] = $event => emailMessageClose()),
        draggable: ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_46, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: sendEmailMessage
        }, {
          default: _withCtx(() => [...(_cache[69] || (_cache[69] = [_createTextVNode("发送", -1)]))]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref: "messageInfoRef",
          model: _unref(messageInfo),
          rules: _unref(messageInforules),
          "label-width": "14rem",
          class: "edit-file"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "邮箱",
                prop: "email"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(messageInfo).email,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => _unref(messageInfo).email = $event),
                  placeholder: "多个邮箱中间用英文逗号分隔",
                  maxlength: "120",
                  clearable: "",
                  onBlur: _cache[28] || (_cache[28] = $event => OnSubscribe()),
                  onInput: _cache[29] || (_cache[29] = $event => _unref(messageInfo).email = _unref(messageInfo).email.replace(/[\u4E00-\u9FA5]/g, ''))
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "任务名称",
                prop: "taskName"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(messageInfo).taskName,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => _unref(messageInfo).taskName = $event),
                  placeholder: "请输入任务名称",
                  maxlength: "30",
                  clearable: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "作业类型",
                prop: "taskType"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(messageInfo).taskTypeName,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => _unref(messageInfo).taskTypeName = $event),
                  readonly: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "无人机",
                prop: "aircraftName"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(messageInfo).aircraftName,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => _unref(messageInfo).aircraftName = $event),
                  readonly: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "卫通设备",
                prop: "satName"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(messageInfo).satName,
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => _unref(messageInfo).satName = $event),
                  readonly: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "载荷设备",
                prop: "otherDevice"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(messageInfo).otherDevice,
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => _unref(messageInfo).otherDevice = $event),
                  readonly: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "综合任务通勤车",
                prop: "carName"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(messageInfo).carName,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => _unref(messageInfo).carName = $event),
                  readonly: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "飞行时间"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(messageInfo).flighttimes,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => _unref(messageInfo).flighttimes = $event),
                  readonly: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "飞行地点",
                prop: "areaName"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(messageInfo).areaName,
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = $event => _unref(messageInfo).areaName = $event),
                  readonly: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "飞行人员",
                prop: "userNames"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(messageInfo).userNames,
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => _unref(messageInfo).userNames = $event),
                  readonly: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "飞行时长"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(messageInfo).flighttime,
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = $event => _unref(messageInfo).flighttime = $event),
                  readonly: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "飞行架次",
                prop: "taskTimes"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(messageInfo).taskTimes,
                  "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => _unref(messageInfo).taskTimes = $event),
                  readonly: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "天气",
                prop: "wea"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(messageInfo).wea,
                  "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => _unref(messageInfo).wea = $event),
                  readonly: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "风速",
                prop: "winMeter"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(messageInfo).winMeter,
                  "onUpdate:modelValue": _cache[42] || (_cache[42] = $event => _unref(messageInfo).winMeter = $event),
                  readonly: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "风向",
                prop: "win"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(messageInfo).win,
                  "onUpdate:modelValue": _cache[43] || (_cache[43] = $event => _unref(messageInfo).win = $event),
                  readonly: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "飞行原因",
                prop: "flightReasons"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(messageInfo).flightReasons,
                  "onUpdate:modelValue": _cache[44] || (_cache[44] = $event => _unref(messageInfo).flightReasons = $event),
                  type: "textarea",
                  readonly: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "飞行结论",
                prop: "result"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(messageInfo).result,
                  "onUpdate:modelValue": _cache[45] || (_cache[45] = $event => _unref(messageInfo).result = $event),
                  type: "textarea",
                  placeholder: "请输入内容",
                  clearable: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "签字确认",
                prop: "sign"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(messageInfo).sign,
                  "onUpdate:modelValue": _cache[46] || (_cache[46] = $event => _unref(messageInfo).sign = $event),
                  placeholder: "请输入",
                  maxlength: "24",
                  clearable: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 22
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "类别",
                prop: "pointIdOptions"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_cascader, {
                  modelValue: _unref(pointIdOptions),
                  "onUpdate:modelValue": _cache[47] || (_cache[47] = $event => _isRef(pointIdOptions) ? pointIdOptions.value = $event : null),
                  size: 'default',
                  style: {
                    "width": "23rem"
                  },
                  "show-all-levels": false,
                  clearable: "",
                  "collapse-tags": true,
                  options: _unref(pointList),
                  props: {
                    multiple: true
                  },
                  onChange: getAlarmInfoListByPointIdList
                }, null, 8, ["modelValue", "options"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 2
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                icon: "Refresh",
                class: "satpro-button",
                onClick: resetAlarmList
              })]),
              _: 1
            })]),
            _: 1
          }), _unref(alarmList).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_41, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(alarmList), (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: "listitem",
              key: index,
              onChange: _cache[48] || (_cache[48] = $event => _ctx.$forceUpdate())
            }, [_withDirectives(_createElementVNode("span", {
              class: "delImg",
              onClick: $event => delImg(item.recognitionUrl)
            }, "+", 8, _hoisted_42), [[_vShow, item.delete === undefined]]), _withDirectives(_createElementVNode("div", _hoisted_43, [_createVNode(_component_el_image, {
              src: item.recognitionUrl,
              style: {
                "height": "38rem"
              }
            }, null, 8, ["src"]), _createElementVNode("div", _hoisted_44, [_createElementVNode("table", _hoisted_45, [_createElementVNode("tr", null, [_cache[67] || (_cache[67] = _createElementVNode("th", null, "告警时间:", -1)), _createElementVNode("td", null, _toDisplayString(item.happenedTime), 1), _cache[68] || (_cache[68] = _createElementVNode("th", null, "告警事件:", -1)), _createElementVNode("td", null, _toDisplayString(item.reportNames), 1)])])])], 512), [[_vShow, item.delete === undefined]])], 32);
          }), 128))])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue"]), _unref(shareOpen) ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 1,
        title: _unref(shareTitle),
        modelValue: _unref(shareOpen),
        "onUpdate:modelValue": _cache[52] || (_cache[52] = $event => _isRef(shareOpen) ? shareOpen.value = $event : null),
        width: "70rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        "align-center": "",
        draggable: ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_47, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: shareSubmit
        }, {
          default: _withCtx(() => [...(_cache[70] || (_cache[70] = [_createTextVNode("确 认", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: shareCancel
        }, {
          default: _withCtx(() => [...(_cache[71] || (_cache[71] = [_createTextVNode("取 消", -1)]))]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref: "taskShareRef",
          model: _unref(shareform),
          rules: _unref(shareformrules),
          "label-width": "14rem"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "选择用户",
                prop: "shareUserIds"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tree_select, {
                  modelValue: _unref(shareform).shareUserIds,
                  "onUpdate:modelValue": _cache[51] || (_cache[51] = $event => _unref(shareform).shareUserIds = $event),
                  data: _unref(userList),
                  multiple: "",
                  props: _unref(defaultProps),
                  "collapse-tags": "",
                  "collapse-tags-tooltip": "",
                  "default-expand-all": "",
                  "filter-node-method": filterNodeMethod,
                  filterable: "",
                  clearable: "",
                  placeholder: "请选择"
                }, null, 8, ["modelValue", "data", "props"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["title", "modelValue"])) : _createCommentVNode("", true)])])])]);
    };
  }
};